export default __webpack_public_path__ + "static/media/5-min.94f8d2cc.jpg";